const containing = ["fuck", "my dick", "suck dick", "suck a dick"];
const startsWith = [
    "sexchess",
    "judishes",
    "chessex",
    "chesssex",
    "kill ",
    "snoppen",
    "pillen",
    "fjomp",
    "blottarn",
    "picken",
    "pillesnopp",
    "putineatsshit",
];
const charReplacements = [
    ["@", "a"],
    ["0", "o"],
    ["1", "i"],
    ["2", "r"],
    ["3", "e"],
    ["4", "a"],
    ["5", "s"],
    ["7", "t"],
    ["8", "b"],
    ["9", "g"],
    ["|<", "k"],
    ["|/|", "m"],
    ["||", "n"],
    ["§", "s"],
    ["$", "s"],
    ["£", "l"],
    ["€", "e"],
    ["(.)", "boob"],
];
function normalizeText(text) {
    let normalized = text
        .toLowerCase()
        .normalize("NFKD")
        .replace(/[\u0300-\u036f]/g, "");
    for (const [from, to] of charReplacements) {
        normalized = normalized.split(from).join(to);
    }
    return normalized;
}
function compactText(text) {
    return text.replace(/[^a-z0-9]/g, "");
}
export function hasBadWord(text) {
    const normalized = normalizeText(String(text || "").replace(/^G\*/i, ""));
    const compacted = compactText(normalized);
    for (const word of containing) {
        const compactedWord = compactText(word);
        if (normalized.includes(word) ||
            (compactedWord && compacted.includes(compactedWord))) {
            return true;
        }
    }
    for (const word of startsWith) {
        const compactedWord = compactText(word);
        if (normalized.startsWith(word) ||
            (compactedWord && compacted.startsWith(compactedWord))) {
            return true;
        }
    }
    return false;
}
//# sourceMappingURL=badWords.js.map